import { render, staticRenderFns } from "./creditTypeSettingEdit.vue?vue&type=template&id=61e5297b&scoped=true"
import script from "./creditTypeSettingEdit.vue?vue&type=script&lang=js"
export * from "./creditTypeSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./creditTypeSettingEdit.vue?vue&type=style&index=0&id=61e5297b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e5297b",
  null
  
)

export default component.exports